import classNames from "classnames";
import Link from "next/link";
import * as React from "react";
import { NewsCard } from "@components/NewsCard";
import type { NewsCard_NewsArticleListItemFragment } from "@components/NewsCard/__generated__/fragments";
import { paths } from "@libs/paths";
import styles from "./index.module.css";
import type { TeamLatestNews_UsersTeamFragment as UsersTeamFragment } from "./__generated__/fragments";

type Props = {
  team: UsersTeamFragment;
  newsArticles: Array<NewsCard_NewsArticleListItemFragment>;
  portrait?: boolean;
};

export const TeamLatestNews: React.FC<Props> = ({
  team,
  newsArticles,
  portrait,
}) => {
  return (
    <>
      <h2 className="c-contentTitle c-contentTitle--fz23">
        {team.name}関連のニュース
      </h2>
      <ul
        className={classNames(
          styles.newsArticlesList,
          portrait && styles.portraitNewsArticlesList
        )}
      >
        {newsArticles.map((n) => (
          <li key={n.id}>
            <NewsCard newsArticle={n} portrait={portrait} />
          </li>
        ))}
      </ul>
      <div className={styles.contentsLink}>
        <Link
          href={paths.teamNewsArticles(
            team.masterSportGenre.slug || "",
            team.slug || ""
          )}
        >
          もっと見る
        </Link>
      </div>
    </>
  );
};
